<template>
  <!-- <div class="m-col">
    <div class="m-row">
      <div class="m-col">
        <div class="m-card item_1"></div>
      </div>
      <div class="m-col">
        <div class="m-card item_2"></div>
      </div>
      <div class="m-col">
        <div class="m-card item_3"></div>
        <div class="m-card item_4"></div>
      </div>
    </div>
    <div class="m-row">
      <div class="m-card item_5"></div>
      <div class="m-card item_6"></div>
    </div>
  </div> -->
  <div class="layout" v-if="isUC == 0">
    <CardInfo class="item_1" :id="id" v-if="id != null" />
    <CardSurface
      class="item_2"
      :dataTemp="dataTemp"
      :time_stamp="timestamp"
      :max="maxminTemp[0]"
      :min="maxminTemp[1]"
    />
    <div style="display: flex; flex-direction: column; gap: 10px">
      <CardChart
        v-for="(item, i) in dataTemp"
        :key="i"
        :color="color[i]"
        :dataTemp="dataTemp"
        v-on:max-min="maxmin"
      />
    </div>
    <CardVibration
      class="item_5"
      :dataVibration="rawData.vibration_detection"
      :time_stamp="timestamp"
    />
    <CardVibrationGragh
      class="item_6"
      :dataVibration="rawData.vibration_graph"
      v-if="rawData.vibration_graph != undefined"
    />
  </div>
  <div class="layout" v-else>
    <CardInfo class="item_1" :id="id" v-if="id != null"> </CardInfo>
    <CardUC
      class="item_2"
      :dataWC="rawData.wc"
      :time_stamp="timestamp"
      :max="maxminTemp[0]"
      :min="maxminTemp[1]"
    >
    </CardUC>
    <div style="display: flex; flex-direction: column; gap: 10px">
      <CardChartUC
        :color="color[0]"
        :dataWC="rawData.wc_graph"
        v-on:max-min="maxmin"
        v-if="rawData.wc != undefined"
      >
      </CardChartUC>
    </div>
  </div>
</template>

<script>
import CardChart from "./components/DM/CardChart.vue";
import CardInfo from "./components/DM/CardInfo.vue";
import CardSurface from "./components/DM/CardSurface.vue";
import CardUC from "./components/DM/CardUC.vue";
import CardChartUC from "./components/DM/CardChartUC.vue";

import CardVibration from "./components/DM/CardVibration.vue";
import CardVibrationGragh from "./components/DM/CardVibrationGragh.vue";
export default {
  components: {
    CardInfo,
    CardSurface,
    CardUC,
    CardChart,
    CardChartUC,
    CardVibration,
    CardVibrationGragh,
  },
  data() {
    return {
      // mac: null,
      id: null,
      info: null,
      arrayName: [
        "ผกาพรรณ ศิลามหาฤกษ์",
        "พรทิพา ศิลามหาฤกษ์",
        "จินตพร ครองจินดา",
        "บัณฑิต จุฑาเทพ ณ อยุธยา",
        "อานันท์ กองการ",
        "ภาณุภัทร พิทักษ์ไทย",
        "กฤตยา พรรณาราย",
        "กฤษฎา พิทักษ์ไทย",
        "พรนภา จิตประสงค์",
        "กนกพรรณ เกิดความสุข",
        "ดนุเดช วรเลิศรัตน์",
        "ชนกนันท์ กล้านอนหงาย",
        "จุฑามณี นิมิตนาม",
        "ดนุเดช พิทักษ์ไทย",
        "ไอริณ ศิวาวงศ์ ",
        "กนกอร ประภาพร ",
        "กชวรรณ พรรณาราย",
        "ปฏิพล พงศ์พิทักษ์",
        "จุไรวรรณ มหานิยม",
        "ปิยนุช จิรามณี",
        "ภูวเดช วิทยเขตปภา",
      ],
      rawData: {},
      dataTemp: [],
      color: ["#8f07ff", "#f707ff"],
      interval: null,
      maxminTemp: [0, 0],
      isUC: 0,
      timestamp: null,
    };
  },
  async mounted() {
    this.id = this.$route.params.id;
    console.log("sdfghj");
    // let nameMachine = ["เครื่องบดอาหาร", "พัดลม", "ตู้กรองฝุ่น"];
    // let No = Number(this.mac.slice(3));
    // let j = No % 21;

    // this.info = {
    //   id: "บด" + Math.ceil(No / 3),
    //   name: nameMachine[No % 3] + " บด" + Math.ceil(No / 3),
    //   mac: this.mac,
    //   model: "BUHLER",
    //   series: "U-AC",
    //   admin: this.arrayName[j],
    //   tel: "0910001111",
    // };
    // console.log(this.info);
    await this.getData();
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
  methods: {
    async getData() {
      try {
        let res = await this.$API.get(`CPF-dashboard/${this.id}`);
        console.log("CPF-dashboard", res.data.message);
        this.dataTemp = [
          {
            surface_temperature: res.data.message.surface_temperature,
            surface_temperature_graph:
              res.data.message.surface_temperature_graph,
          },
        ];
        this.rawData = res.data.message;
        this.isUC = res.data.message.status;
        this.timestamp = this.$moment(this.rawData.vibration_graph.x[this.rawData.vibration_graph.x.length-1][0]-1000*60*60*7).format('YYYY-MM-DD HH:mm:ss');// +5 hr
        console.log(this.timestamp);
      } catch (error) {}
      this.interval = setTimeout(async () => {
        await this.getData();
      }, 1000 * 20);
    },
    maxmin(value) {
      this.maxminTemp = value;
    },
  },
  computed: {
    rawDataCom() {
      return this.rawData;
    },
  },
};
</script>

<style lang="scss" scoped>
.m-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  width: 100%;
  max-width: 100%;
}
.m-col {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 10px;
  width: auto;
  max-width: 100%;
  flex-grow: 1;
  flex-basis: 0;
}
.layout {
  display: grid;
  grid: auto auto / 25% 30% calc(45% - 20px);
  gap: 10px;
}

.item_1,
.item_2 {
  height: 100%;
}

@media only screen and (min-width: 600px) {
  .item_6 {
    grid-column: 2/4;
    //   width: calc(100% - calc(calc(100% - 20px) / 3));
  }
}
@media only screen and (max-width: 1100px) {
  .layout {
    // grid: auto auto auto/ 30% 30% calc(40% - 20px);
    grid: auto auto auto/ 30% 30% calc(40% - 20px);
  }
}
@media only screen and (max-width: 600px) {
  .layout {
    grid: 400px auto auto auto auto auto / 100%;
  }
}
</style>